// extracted by mini-css-extract-plugin
export default {"menuControlsAction__icon_styleRed":"c-a_ey"};